import { AUDIENCE } from "./data";
import { Reveal, Overline } from "./primitives";

export const WhoItHelps = () => {
  return (
    <section
      id="who-it-helps"
      data-testid="who-it-helps-section"
      className="relative bg-slate-50 py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <Overline>Who It Helps</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-heading text-4xl font-bold leading-[1.06] tracking-tight text-slate-900 sm:text-5xl">
              Built for the people who plan pipelines
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {AUDIENCE.map((a, i) => (
            <Reveal key={a.title} delay={i * 0.09}>
              <div className="group flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={a.image}
                    alt={a.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0e3f70]/60 to-transparent" />
                  <div className="absolute bottom-4 left-4 inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-white/20 bg-white/90 text-[#1a6fc4] backdrop-blur">
                    <a.icon className="h-6 w-6" strokeWidth={1.7} />
                  </div>
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <h3 className="font-heading text-2xl font-bold tracking-tight text-slate-900">
                    {a.title}
                  </h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-slate-600">
                    {a.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
